import { configureStore } from '@reduxjs/toolkit';
import { waveSlice } from '@/redux/slices';

export const store = configureStore({
  reducer: {
    wave: waveSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
